import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDocs_1 from '../../../../../libraries/Images/createAConnectionWithDocs_1.png';
import createAConnectionWithDocs_2 from '../../../../../libraries/Images/createAConnectionWithDocs_2.png';
import createAConnectionWithDocs_3 from '../../../../../libraries/Images/createAConnectionWithDocs_3.png';
import createAConnectionWithDocs_4 from '../../../../../libraries/Images/createAConnectionWithDocs_4.png';
import createAConnectionWithDocs_5 from '../../../../../libraries/Images/createAConnectionWithDocs_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdocs">
                1.&nbsp;{translate('createaconnectionwithdocs')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "Docs" among them.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_2} width="75%" />
            </Zoom>
            <p>When you click "Docs", the user's Google account selection screen is displayed. Please select an account to use for the connection.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>When you select an account, "RPA CLOUD" will request access on your behalf. Agree to grant the above access permission to "RPA CLOUD" and click "Allow".</p>
            <Zoom>
                <img src={createAConnectionWithDocs_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see a Docs tab after the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithDocs_5} width="50%"/>
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to perform the steps in the Docs.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);